import type { MeDataExportDownloadResult, MeDataExportJob } from "@evolua/api-client";

const jobs: MeDataExportJob[] = [];

function makePayload(id: string): string {
  return JSON.stringify(
    {
      schemaVersion: "1.0",
      generatedAt: new Date().toISOString(),
      exportId: id,
      inventoryRef: "docs/lgpd/inventario-e-bases-legais.md",
      titular: { subject: "demo-employee", employeeId: "demo", tenantId: "demo-tenant" },
      categories: {
        identification: { fullName: "Ana Colaboradora", displayName: "Ana" },
        documents: { cpf: "123.456.789-00" },
        contact: { email: "employee@demo.local" },
        employment: { departmentName: "Engenharia" },
        compensation: { salaryAmount: 8500, payslips: [] },
        banking: { bankAccount: "0001 / 12345-6" },
        vacations: { periods: [], history: [] },
        health: { items: [], note: "Fora do MVP mock" },
        credentials: { note: "Senhas não exportadas", mfaEnabled: null },
        platform: { correctionRequests: [] },
        audit: { exportRequestAuditId: `audit-${id.slice(0, 8)}` },
      },
    },
    null,
    2,
  );
}

const payloads = new Map<string, string>();

/** Demo LGPD export (FASE-06-T41) — completa imediatamente. */
export function requestDemoMeDataExport(): MeDataExportJob {
  const id = crypto.randomUUID();
  const now = new Date();
  const expiresAt = new Date(now.getTime() + 15 * 60_000).toISOString();
  const job: MeDataExportJob = {
    id,
    status: "READY",
    requestedAt: now.toISOString(),
    readyAt: now.toISOString(),
    expiresAt,
    downloadPath: `/v1/me/data-exports/${id}/download`,
    requestAuditId: crypto.randomUUID(),
  };
  payloads.set(id, makePayload(id));
  jobs.unshift(job);
  return { ...job };
}

export function listDemoMeDataExports(): { data: MeDataExportJob[] } {
  return { data: jobs.map((j) => ({ ...j })) };
}

export function getDemoMeDataExport(id: string): MeDataExportJob {
  const job = jobs.find((j) => j.id === id);
  if (!job) throw new Error("Exportação não encontrada");
  return { ...job };
}

export function downloadDemoMeDataExport(id: string): MeDataExportDownloadResult {
  const job = getDemoMeDataExport(id);
  const content = payloads.get(id);
  if (!content || job.status !== "READY" || !job.expiresAt) {
    throw new Error("Exportação indisponível");
  }
  return {
    filename: `evolua-lgpd-export-${id.slice(0, 8)}.json`,
    content,
    auditId: crypto.randomUUID(),
    expiresAt: job.expiresAt,
  };
}
